var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossRedBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-cancel-red"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cancel-red",
    clipPath: "url(#clip-cancel-red)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23287",
    "data-name": "Group 23287"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29763",
    "data-name": "Rectangle 29763",
    width: 16,
    height: 16,
    rx: 8,
    fill: "#fe5151"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16723",
    "data-name": "Group 16723",
    transform: "translate(5.152 5.153)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18626",
    "data-name": "Path 18626",
    d: "M3.272,2.849,5.608.513A.3.3,0,0,0,5.184.089L2.848,2.425.512.089A.3.3,0,0,0,.088.513L2.424,2.849.088,5.185a.3.3,0,0,0,.424.424L2.848,3.273,5.184,5.609a.3.3,0,0,0,.424-.424Z",
    transform: "translate(0 -0.001)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossRedBg);
export default __webpack_public_path__ + "static/media/cross_red_bg.0ea856efb3f3b8bc94e29786bf0fb717.svg";
export { ForwardRef as ReactComponent };